import { ADD_NEWS, GET_NEWS, GET_NEWS_LIST, REMOVE_NEWS, SET_NEWS_FILTER_TYPE, SET_NEWS_POSTER_PROPS, UPDATE_NEWS } from '@jumbo/constants/ActionTypes';
import { client } from 'services/http';
import { fetchError, fetchStart, fetchSuccess } from './Common';


//For setting Filtertype
export const setNewsFilterType = filterType => {
  return {
    type: SET_NEWS_FILTER_TYPE,
    payload: filterType,
  };
};

export const getNewsList = (params) => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .get(`/share/v3/news`, {
        params: { ...params }
      })
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_NEWS_LIST, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.response.data.error[0]));
      });
  };
};

export const createNews = (news, setUploadLoading) => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .post(`/share/v3/news`, news)
      .then(data => {
        if (data.status === 200) {
          setUploadLoading(false);
          dispatch(fetchSuccess('خبر با موفقیت ثبت شد'));
          dispatch({ type: ADD_NEWS, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        const errors = error.response.data.errors
        if (errors?.base?.length > 0) {
          dispatch(fetchError(errors?.base[0]))
        } else if (errors?.news) {
          dispatch(fetchError(errors?.news));
        } else {
          dispatch(fetchError('خطا سروری'));
        }
      });
  };
};

export const updateNews = (newsID, news, setUploadLoading) => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .put(`/share/v3/news/${newsID}`, news)
      .then(data => {
        if (data.status === 200 || data.status === 201) {
          setUploadLoading(false);
          dispatch(fetchSuccess('خبر با موفقیت بروزرسانی شد'));
          dispatch({ type: UPDATE_NEWS, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.response.data.error[0]));
      });
  };
};

export const getNews = newsId => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .get(`/share/v3/news/${newsId}`)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_NEWS, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.response.data.error[0]));
      });
  };
};

export const deleteNews = newsId => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .delete(`/share/v3/news/${newsId}`)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess('خبر مورد نظر با موفقیت حذف شد'));
          dispatch({ type: REMOVE_NEWS, payload: newsId });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.response.data.error[0]));
      });
  };
};

export const setNewsPosterProps = poster => {
  return dispatch => {
    dispatch({
      type: SET_NEWS_POSTER_PROPS,
      payload: poster,
    });
  };
};